import { Link } from 'react-router-dom';

const footerLinks = [
  { href: '/', label: 'Accueil' },
  { href: '/a-propos', label: 'À propos' },
  { href: '/contact', label: 'Contact' },
  { href: '/conditions-generales', label: 'Conditions générales' },
  { href: '/politique-de-confidentialite', label: 'Politique de confidentialité' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#F3F3F1] border-t border-gray-200">
      <div className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/a3fc7c95-47a5-4f53-b526-26ceb008022d.png"
                alt="WABICH"
                className="h-8 w-auto object-contain"
              />
            </Link>
            <div
              className="space-y-1 text-sm text-gray-500 leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
            >
              <p className="text-gray-800 font-medium" style={{ fontWeight: 500 }}>Joanna Maria Wabich</p>
              <p>SIRET : 102 006 269 00017</p>
              <p className="mt-3">91 Rue Nationale</p>
              <p>59800 Lille, France</p>
              <a
                href="tel:+33699068840"
                className="block mt-3 hover:text-gray-900 transition-colors cursor-pointer"
              >
                +33 6 99 06 88 40
              </a>
              <a
                href="mailto:joannawab1ch@outlook.com"
                className="block hover:text-gray-900 transition-colors cursor-pointer"
              >
                joannawab1ch@outlook.com
              </a>
            </div>
          </div>

          {/* Navigation column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase text-gray-400 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-gray-500 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Activity column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase text-gray-400 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Activité
            </h4>
            <div
              className="space-y-2 text-sm text-gray-500 leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
            >
              <p>Design graphique</p>
              <p>Identité visuelle</p>
              <p>Conception créative</p>
              <p className="mt-4 text-xs text-gray-400">
                NAF : 74.10Z – Activités spécialisées de design
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p
            className="text-xs text-gray-400"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            © {year} WABICH – Tous droits réservés.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/conditions-generales"
              className="text-xs text-gray-400 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              CGU
            </Link>
            <Link
              to="/politique-de-confidentialite"
              className="text-xs text-gray-400 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
